<template>
    <div v-if="loaded" :class="`department-card ${department.AdditionalClasses}`"
        v-bind:class="{ 'department-card--campaign': department.HasCampaign, 'department-card--expanding': department.Expanding, 'department-card--under-construction': department.UnderConstruction, 'department-card--pending': department.Pending, 'department-card--selected': selected }"
        :data-id="department.Id">
        <div v-if="department.Pending" class="department-card__notification">
            <span>
                {{ dictionary.DepartmentCardPendingNotification }}
            </span>
            <span v-if="department.OpeningDate">{{ department.OpeningDate }}</span>
        </div>
        <div v-else-if="department.UnderConstruction" class="department-card__notification">
            <span>
                {{ dictionary.DepartmentCardNewNotification }}
            </span>
            <span v-if="department.OpeningDate">{{ department.OpeningDate }}</span>
        </div>
        <div v-else-if="department.Expanding" class="department-card__notification">
            <span>
                {{ dictionary.DepartmentCardExpandingNotification }}
            </span>
            <span v-if="department.OpeningDate">{{ department.OpeningDate }}</span>
        </div>
        <div v-else-if="department.InstantBooking" class="department-card__notification">
            {{ dictionary.DepartmentCardInstantNotification }}
        </div>
        <div v-else-if="department.HasCampaign" class="campaign-stamp campaign-stamp--card" :class="{'campaign-stamp--free':department.Campaign.IsFree}">
            <span v-if="!department.Campaign.IsFree" class="campaign-stamp__headline">{{ dictionary.CampaignHeadline }}</span>
            <span class="campaign-stamp__percentage">
                <span v-if="department.Campaign.DiscountType == 1">{{ department.Campaign.IsFree ? 'Gratis' : `${department.Campaign.Price}%` }}</span>
                <span v-else>{{ department.Campaign.Price }}.-</span>
            </span>
            <span class="campaign-stamp__validtrough">{{ department.Campaign.Duration > 1 ? dictionary.CampaignDurationMultiperiod.includes('{0}') ? dictionary.CampaignDurationMultiperiod.replace('{0}',department.Campaign.Duration) : dictionary.CampaignDurationMultiperiod : dictionary.CampaignDuration.includes('{0}') ? dictionary.CampaignDuration.replace('{0}',department.Campaign.Duration) : dictionary.CampaignDuration }}</span>
        </div>
        <div v-else-if="department.FixedPrice" class="campaign-stamp campaign-stamp--card" :class="{'campaign-stamp--fixed-price':!department.HasFixedPriceValue, 'campaign-stamp--fixed-price-with-value':department.HasFixedPriceValue}">
            <span class="campaign-stamp__percentage">
                {{department.HasFixedPriceValue ? dictionary.DepartmentStampFixedPriceWithValueLine1.replace('{value}',department.FixedPriceValue) : dictionary.DepartmentStampFixedPriceLine1}}
            </span>
            <span class="campaign-stamp__validtrough" v-html="department.HasFixedPriceValue ? dictionary.DepartmentStampFixedPriceWithValueLine2 : dictionary.DepartmentStampFixedPriceLine2">
            </span>
        </div>
        <div v-if="department.HasVolumeLabel && department.VolumeLabel == -1"
            class="department-card__notification-secondary">
            {{ dictionary.DepartmentCardLabel - 1 }}
        </div>
        <div v-if="department.HasVolumeLabel && department.VolumeLabel == 1"
            class="department-card__notification-secondary">
            {{ dictionary.DepartmentCardLabel + 1 }}
        </div>
        <div v-if="department.HasImageUrl" class="department-card__image">
            <img class="image-cover lazyloaded" :src="department.ImageUrl" loading="lazy" />
        </div>
        <div v-if="department.HasStampPrice" class="department-card__price-stamp">
            <span class="department-card__price-stamp__line1">
                {{ dictionary.DepartmentCardPriceCircleLine1 }}
            </span>
            <span class="department-card__price-stamp__price">{{ department.StampPrice }} kr</span>
            <span class="department-card__price-stamp__line2">{{ dictionary.DepartmentCardPriceCircleLine2 }}</span>
        </div>

        <div class="department-card__content">
            <p class="department-card__content__city">
                {{ department.City }}
            </p>

            <p class="department-card__content__address">
                {{ department.Address }}
            </p>


            <div class="department-card__content__emphasized">
                <b v-if="department.HasEmphasizedText">{{ department.EmphasizedTextLine1 }}</b><br />

                <p v-if="department.HasEmphasizedText && department.HasPrice">
                    {{ department.EmphasizedTextLine2 }}
                </p>

            </div>
            <a v-if="department.HasUrl && !noSelect" v-on:click="departmentSelectHandler"
                class="department-card__content__button">
                {{ dictionary.DepartmentCardCtaText }}
            </a>
            <a v-else="department.HasUrl && noSelect" :href="department.Url + urlAddition"
                class="department-card__content__button">
                {{ dictionary.DepartmentCardCtaText }}
            </a>
        </div>
        <div v-if="department.SolarPowered" class="department-card__bottom-notification">
            <span>{{ dictionary.DepartmentCardSolarPoweredNotification }}</span>
        </div>
    </div>

</template>

<script>

export default {
    name: "departmentCard",
    props: ["department", "noSelect", "selected","urlAddition"],
    data() {
        return {
            dictionary: [],
            loaded:false,
        };
    },
    created() {
        const vm = this;
        fetch("/umbraco/api/dictionaryapi/GetDepartmentCardDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
                vm.loaded  = true
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        departmentSelectHandler() {
            this.$emit('departmentSelect', this.department.Id);
        }
    }
};
</script>
